/** Generic ascending/descending sort direction for list endpoints. */
export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
